import { createApp, markRaw } from 'vue'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'
import apolloClient from "./plugins/apollo";
import { createApolloProvider } from '@vue/apollo-option'
import './styles/theme.css' /* Design Tokens - импортируем первым */
import './styles/app.css'
import { syncBrandColors } from './utils/colorSync'
import { typo, typoDirective } from './utils/typography'

// Синхронизируем цвета бренда с CSS переменными
syncBrandColors()

const pinia = createPinia();

pinia.use(({ store }) => {
  store.$router = markRaw(router)
});

const apolloProvider = createApolloProvider({
    defaultClient: apolloClient,
  });


const app = createApp(App);

app.config.globalProperties.$typo = typo
app.directive('typo', typoDirective)

app.use(pinia).use(apolloProvider).use(router).mount('#app')